import './sponsor.css';
import React, { useEffect, useState } from 'react';

function Sponsor() {
  const [boxStatesA, setBoxStatesA] = useState(Array(25).fill(false));
  const [boxStatesB, setBoxStatesB] = useState(Array(25).fill(true));

  const handleBoxClickA = (idx) => {
    setBoxStatesA(prev => {
      const updated = [...prev];
      updated[idx] = !updated[idx];
      return updated;
    });
  };

  const handleBoxClickB = (idx) => {
    setBoxStatesB(prev => {
      const updated = [...prev];
      updated[idx] = !updated[idx];
      return updated;
    });
  };

  const getBoxLabelText = (idx) => {
    // Mapping: 20->5a, 2->5b, 3->5c, ..., 19->5u, 0->5v, 1->5w, 21->5x, 22->5y, 23->5z, 24->5z+
    const sequence = [20, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 0, 1, 21, 22, 23, 24];
    const pos = sequence.indexOf(idx);
    if (pos === -1) return '';
    return `5${String.fromCharCode(97 + pos)}`;
  };

  useEffect(() => {
    // Check if user prefers dark mode
    const darkModePreference = window.matchMedia('(prefers-color-scheme: dark)').matches;
    
    if (darkModePreference) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }

    // Listen for changes in color scheme preference
    const mediaQueryList = window.matchMedia('(prefers-color-scheme: dark)');
    const handleColorSchemeChange = (evt) => {
      if (evt.matches) {
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
      }
    };

    mediaQueryList.addEventListener('change', handleColorSchemeChange);
    return () => mediaQueryList.removeEventListener('change', handleColorSchemeChange);
  }, []);

  return (
    <div className="Home sponsor-page">
        <div className="section-header spacing-top">Figure 1: Perimeter</div>
        <div className="container-main">
            <div className="border-strip border-top">
                {[...Array(8)].map((_, i) => (
                    <div key={`top-${i}`} className="border-cell">
                        {`1${String.fromCharCode(97 + i)}`}
                    </div>
                ))}
            </div>
            <div className="border-strip border-left">
                {[...Array(4)].map((_, i) => (
                    <div key={`left-${i}`} className="border-cell">
                        <span className="text-rotated-left">{`2${String.fromCharCode(97 + i)}`}</span>
                    </div>
                ))}
            </div>
            {[...Array(25)].map((_, i) => (
                <React.Fragment key={i}>
                    <div 
                        className={`slot slot${i} ${boxStatesA[i] ? 'revealed' : ''}`} 
                        onClick={() => handleBoxClickA(i)}
                    >
                        <div className='label-text'></div>
                    </div>
                    <div className={`slot-backing slot${i}-backing`}></div>
                </React.Fragment>
            ))}
            <div className="border-strip border-right">
                {[...Array(4)].map((_, i) => (
                    <div key={`right-${i}`} className="border-cell">
                        <span className="text-rotated-right">{`4${String.fromCharCode(97 + i)}`}</span>
                    </div>
                ))}
            </div>
            <div className="border-strip border-bottom">
                {[...Array(8)].map((_, i) => (
                    <div key={`bottom-${i}`} className="border-cell">
                        {`2${String.fromCharCode(97 + i)}`}
                    </div>
                ))}
            </div>
        </div>
        <div className="section-header">Figure 2: Boxes</div>
        <div className="container-main container-secondary">
            <div className="border-strip border-top">
                {[...Array(8)].map((_, i) => (
                    <div key={`top2-${i}`} className="border-cell border-cell-alt">
                    </div>
                ))}
            </div>
            <div className="border-strip border-left">
                {[...Array(4)].map((_, i) => (
                    <div key={`left2-${i}`} className="border-cell border-cell-alt">
                    </div>
                ))}
            </div>
            {[...Array(25)].map((_, i) => (
                <React.Fragment key={`box2-${i}`}>
                    <div 
                        className={`slot slot${i} slot-variant ${boxStatesB[i] ? 'revealed' : ''}`} 
                        onClick={() => handleBoxClickB(i)}
                    >
                        <div className='label-text variant-label'>{getBoxLabelText(i)}</div>
                    </div>
                    <div className={`slot-backing slot${i}-backing`}></div>
                </React.Fragment>
            ))}
            <div className="border-strip border-right">
                {[...Array(4)].map((_, i) => (
                    <div key={`right2-${i}`} className="border-cell border-cell-alt">
                    </div>
                ))}
            </div>
            <div className="border-strip border-bottom">
                {[...Array(8)].map((_, i) => (
                    <div key={`bottom2-${i}`} className="border-cell border-cell-alt">
                    </div>
                ))}
            </div>
        </div>
        <div className="section-header">Pricing</div>
        <div className="price-display">
            <div className="price-category">
                <h3>Perimiter - $400 each</h3>
                <div className="price-layout">
                    <div className="price-group">
                        <h4>Top Row</h4>
                        {['1a', '1b', '1c', '1d', '1e', '1f', '1g', '1h'].map(lbl => (
                            <div key={lbl} className="price-row">
                                <span className="price-id">{lbl}</span>
                                <span className="price-amount">$400</span>
                            </div>
                        ))}
                    </div>
                    <div className="price-group">
                        <h4>Left Column</h4>
                        {['2a', '2b', '2c', '2d'].map(lbl => (
                            <div key={lbl} className="price-row">
                                <span className="price-id">{lbl}</span>
                                <span className="price-amount">$400</span>
                            </div>
                        ))}
                    </div>
                    <div className="price-group">
                        <h4>Right Column</h4>
                        {['4a', '4b', '4c', '4d'].map(lbl => (
                            <div key={lbl} className="price-row">
                                <span className="price-id">{lbl}</span>
                                <span className="price-amount">$400</span>
                            </div>
                        ))}
                    </div>
                    <div className="price-group">
                        <h4>Bottom Row</h4>
                        {['3a', '3b', '3c', '3d', '3e', '3f', '3g', '3h'].map(lbl => (
                            <div key={lbl} className="price-row">
                                <span className="price-id">{lbl}</span>
                                <span className="price-amount">$400</span>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="price-category">
                <h3>Calendar Cells - Starting at $300</h3>
                <div className="price-layout slot-price-layout">
                    {[20, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 0, 1, 21, 22, 23, 24].map((slotIdx, pos) => {
                        const lbl = getBoxLabelText(slotIdx);
                        const cost = 300 - (pos * 5);
                        return (
                            <div key={lbl} className="price-row">
                                <span className="price-id">{lbl}</span>
                                <span className="price-amount">${cost}</span>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    </div>
  );
}

export default Sponsor;